import Vue from 'vue';

Vue.component('activities-list', {
    props: {
        /**
         * Default value fetches upcoming event only,
         * 'true' value fetched upcoming and past events.
         */
        historical: {
            type: Boolean,
            default: false,
        },
        /**
         * Default value maps upcoming events,
         * Set to 'false' if you only want to map historical events.
         *
         * NOTE: Mapping of historical events only works if the
         * historical property is also set to true.
         */
        upcoming: {
            type: Boolean,
            default: true,
        },
        lessonContentTypes: Array,
    },

    data() {
        return {
            activities: [],
            initialLimit: 5,
            showMore: false,
            loading: true,
        };
    },

    computed: {
        limitedActivities() {
            if (this.showMore) {
                return this.activities;
            }

            if (this.activities.length <= this.initialLimit) {
                return this.activities;
            }

            return this.activities.slice(0, this.initialLimit);
        },
    },

    mounted() {
        this.fetch();
    },

    methods: {
        fetch() {
            this.$api.gms.reservation.listVisits({ historical: this.historical })
            .then((response) => {
                this.activities = this.prepareActivities(response.result);
                this.loading = false;
            })
            .catch((error) => {
                console.log(error);
            });
        },

        prepareActivities(activities) {
            // Leave out empty activities.
            let filtered = _.filter(activities, (activity) => activity.flights || activity.lessons);

            // If we are not looking at the upcoming view, leave them out.
            if (!this.upcoming) {
                const now = new Date();

                filtered = _.filter(activities, (object) => {
                    const activityDate = new Date(object.date);
                    return activityDate < now.setDate(now.getDate() - 1);
                });
            }

            return _.map(filtered, (object) => {
                const activity = {
                    date: object.date,
                    open: false,
                    mainBookerName: object.mainBookerName,
                };

                if (object.flights) {
                    const firstClaim = object.flights[0].reservations[0];
                    const params = {
                        type: 'golf',
                        startTime: firstClaim.startTime,
                        numberOfHoles: firstClaim.nrOfHoles,
                        flightIndex: object.flights[0].flightIndex,
                    };

                    // Merge objects using ES6 array seperator.
                    // https://davidwalsh.name/merge-objects.
                    return { ...activity, ...params };
                }

                const firstLesson = object.lessons[0];
                const lesson = _.find(this.lessonContentTypes, { id: firstLesson.lessonContentTypeUuids[0] });

                const params = {
                    type: 'lesson',
                    startTime: firstLesson.time,
                    lessonType: (lesson) ? lesson.name : 'Unknown',
                    nrOfMembers: firstLesson.nrOfMembers,
                };

                // Merge objects using ES6 array seperator.
                // https://davidwalsh.name/merge-objects.
                return { ...activity, ...params };
            });
        },
    },
});
